import React from 'react';
import { Radar } from 'react-chartjs-2';
import { useT } from '../i18n';
import { Chart as ChartJS, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from 'chart.js';

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

function RadarChartComponent({ data }) {
  const t = useT();
  const chartData = {
    labels: [
      t('토지가격'),
      t('투자가치'),
      t('법적 규제'),
      t('소음'),
      t('인구 규모'),
      t('교통 및 접근성'),
      t('지형 및 토양'),
      t('편의시설'),
      t('인프라 및 공공시설'),
    ],
    datasets: [
      {
        label: t('평가'),
        data: data,
        backgroundColor: 'rgba(171, 53, 213, 0.2)',
        borderColor: 'rgba(175, 82, 222, 1)',
        borderWidth: 1,
        // 시각적 포인트는 숨김
        pointRadius: 0,
        // 호버 인식 영역만 반지름 10px로 확대
        pointHitRadius: 20,
        // 시각적 호버 점 크기는 필요 시 별도 지정
        pointHoverRadius: 4,
        pointHoverBackgroundColor: 'rgba(175, 82, 222, 1)',

      },
    ],
  };

  const options = {
    scales: {
      r: {
        angleLines: {
          display: false,
        },
        suggestedMin: 1,
        suggestedMax: 10,
        ticks: {
          stepSize: 1,
          font: {
            size: 10,
          },
        },
        pointLabels: {
          font: {
            size: 11,
            family: 'Pretendard',
          },
          padding: 0,
        }
      },
    },
    plugins: {
      tooltip: {
        // 툴팁 위치 모드: nearest 또는 average
        position: 'nearest',
        // 호버한 점 기준 x축 정렬: 'right' (오른쪽)
        xAlign: 'left',
        // 호버한 점 기준 y축 정렬: 'bottom' (아래)
        yAlign: 'bottom',

        // 툴팁 스타일 예시 (선택)
        backgroundColor: 'rgba(0,0,0,0.7)',
        titleFont: { size: 13 },
        bodyFont: { size: 12 },
        padding: 8,
        cornerRadius: 4,

        callbacks: {
          label: ctx => `${ctx.dataset.label}: ${t('{n}점', { n: ctx.raw })}`,
        },
      },

      legend: {
        display: true,           // 범례 표시 여부
        position: 'bottom',         // top, bottom, left, right 중 선택
        align: 'end',         // start, center, end
        fullWidth:false,
        labels: {
          boxWidth: 20,        // 색상 박스 가로 크기(px)
          boxHeight: 6,       // 색상 박스 세로 크기(px)
          padding: 10,         // 아이템 간 간격(px)
          font: {
            size: 10,        // 범례 폰트 크기
            family: "Pretendard", // 폰트 패밀리
            weight: '300',
          },
          color: '#333',       // 폰트 색상
        },
      },

    },

    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div style={{ width: '100%', height: '300px' }}>
      <Radar data={chartData} options={options} />
    </div>
  );
}

export default RadarChartComponent;
